import React, { useContext, useEffect } from "react";
import {
  useTable,
  useSortBy,
  usePagination,
  useGlobalFilter,
  useFilters,
} from "react-table";
import "bootstrap/dist/css/bootstrap.min.css";
import "./Table.css";
import Sortdownarrow from "../../IconComponents/Sortdownarrow";
import Sortuparrow from "../../IconComponents/Sortuparrow";
import Sortingarrow from "../../IconComponents/Sortingarrow";
import TableHeader from "./TableHeader/TableHeader";
import { useTranslation } from "react-i18next";
import i18n from "i18next";
import { ThemeContext } from "../../..";
import Incidentheader from "./TableHeader/Incidentheader";

// Default filter UI for a column
const DefaultColumnFilter = ({
  column: { filterValue, preFilteredRows, setFilter },
}) => {
  return (
    <input
      value={filterValue || ""}
      onChange={(e) => {
        setFilter(e.target.value || undefined); // undefined to remove the filter entirely
      }}
      placeholder={`Filter...`}
      style={{
        width: "100%",
        padding: "5px",
        border: "1px solid #ccc",
        borderRadius: "4px",
        marginTop: "5px",
      }}
    />
  );
};

const IncidentShowTableData = ({ selectedRowId, onRowClick, ...props }) => {
  const {
    columns,
    scroll = false, // Default to false if not provided
    data,
    numberOfRows,
    headerTableHeadStyle = {},
    tableStyle = {},
    showRowCount = true,
    rowCount,
    tabChanger = false,
    activeTab,
    setActiveTab,
    searchData,
    setSearchData = () => { },
    enableColumnFilters = false, // New prop to control filter visibility
    disbalePaginationFilter = false,
    disbalePaginationFilter1 = false,
    disbalePaginationFilter2 = false,
  } = props;

  const {
    getTableProps,
    getTableBodyProps,
    headerGroups,
    prepareRow,
    page,
    canPreviousPage,
    canNextPage,
    pageOptions,
    gotoPage,
    nextPage,
    previousPage,
    setPageSize,
    setGlobalFilter,
    rows,
    state: { pageIndex, globalFilter, pageSize },
  } = useTable(
    {
      columns,
      data,
      defaultColumn: { Filter: DefaultColumnFilter }, // Add default filter UI
      initialState: { pageIndex: 0, pageSize: numberOfRows },
    },
    useFilters, // Use filters hook
    useGlobalFilter,
    useSortBy,
    usePagination
  );
  const { t } = useTranslation();
  const { theme } = useContext(ThemeContext);

  const translateNumber = (number) => {
    const numberString = number.toString();
    return i18n.t(`numbers.${numberString}`, { defaultValue: numberString });
  };
  let tempRowCount = globalFilter ? rows.length : rowCount || data.length;
  let tempPageIndex = pageIndex;
  let tempPageSize = pageSize;

  if (tempPageIndex === undefined || tempPageIndex === null) {
    tempPageIndex = 0;
  }
  if (tempRowCount === undefined || tempRowCount === null) {
    tempRowCount = 0;
  }
  if (tempPageSize === undefined || tempPageSize === null) {
    tempPageSize = 10;
  }

  const startIndex = tempPageIndex * tempPageSize + 1 || 1;
  const endIndex =
    Math.min((tempPageIndex + 1) * tempPageSize, tempRowCount) || tempRowCount;

  const translatedStartIndex = startIndex;
  const translatedEndIndex = endIndex;
  const translatedRowCount = tempRowCount;
  useEffect(() => {
    setPageSize(numberOfRows);
  }, [numberOfRows]); // Update page size if numberOfRows changes

  useEffect(() => {
    if (globalFilter) {
      const pageData = page?.map((row) => row.original);
      setSearchData(pageData ? pageData : []);
    } else {
      const pageData = rows?.map((row) => row.original);
      setSearchData(pageData ? pageData : []);
    }
  }, [globalFilter, rows]);

  // Dynamically set className
  const tableClassName = scroll
    ? "table iccc--table-scroll"
    : "table iccc--table";

  return (
    <div className="tabl_container" style={{
      backgroundColor: theme === "light" ? "#ffffff" : "#1f2a44", // white for light, dark for dark
      padding: "1rem",
      borderRadius: "8px",
    }}>
      <Incidentheader
        {...props}
        searchValue={globalFilter || ""}
        onSearchHandler={setGlobalFilter}
      />
      {tabChanger && (
        <div className="tabchanger_container">
          <div
            className={`tab ${activeTab === "Affected" ? "active" : ""}`}
            onClick={() => setActiveTab("Affected")}>
            Affected
          </div>
          <div
            className={`tab ${activeTab === "Partially Affected" ? "active" : ""
              }`}
            onClick={() => setActiveTab("Partially Affected")}>
            Partially Affected
          </div>
        </div>
      )}

      <div className="iccc__table--container" style={{
        ...tableStyle,
        backgroundColor: theme === "light" ? "#ffffff" : "#1f2a44", // override default
      }}>
        <table {...getTableProps()} className={tableClassName} id="report_table">
          <thead>
            {headerGroups.map((headerGroup, index) => (
              <tr {...headerGroup.getHeaderGroupProps()} key={index}>
                {headerGroup.headers.map((column, index) => (
                  <th
                    {...column.getHeaderProps(column.getSortByToggleProps())}
                    style={headerTableHeadStyle}
                    key={index}>
                    {column.render("Header")}
                    {!column.disableSortBy &&
                      (column.isSorted ? (
                        column.isSortedDesc ? (
                          <Sortdownarrow />
                        ) : (
                          <Sortuparrow />
                        )
                      ) : (
                        <Sortingarrow />
                      ))}
                    {enableColumnFilters && column.canFilter && (
                      <div>{column.render("Filter")}</div>
                    )}
                  </th>
                ))}
              </tr>
            ))}
          </thead>
          <tbody {...getTableBodyProps()}>
            {page.length > 0 ? (
              page.map((row, i) => {
                prepareRow(row);
                const isSelected = row.original.id === selectedRowId;
                return (
                  <tr
                    {...row.getRowProps()}
                    key={i}
                    onClick={() => onRowClick(row.original.id)}  // Handle row click
                    style={{
                      cursor: 'pointer',
                      backgroundColor: isSelected ? '#1890ff' : 'inherit', // Light blue background for selected row
                      // borderLeft: isSelected ? '4px solid #1890ff' : 'none',
                      transition: 'all 0.2s ease', // Smooth transition
                      width: '100%',
                    }}
                  >
                    {row.cells.map((cell, i) => (
                      <td key={i} {...cell.getCellProps()}
                        style={{
                          textAlign: cell.column.leftAlign ? "left" : "inherit",
                          backgroundColor: 'inherit', // Inherit the row background
                          color: isSelected ? '#ffffff' : 'inherit', // Optional: change text color for selected row
                        }}>
                        {cell.render("Cell")}
                      </td>
                    ))}
                  </tr>
                );
              })
            ) : (
              <div></div>
              // ... no data row ...
            )}
          </tbody>
        </table>
      </div>
      <div className="d-flex justify-content-between align-items-center">
        {!disbalePaginationFilter2 &&
          <div className="float-start m-2 mt-2 ms-3">
            {showRowCount && (
              <div className="float-start m-2 mt-1 ms-3 pagecount-style">
                {t("showingentriestable.showing")} {translatedStartIndex}{" "}
                {t("showingentriestable.to")} {translatedEndIndex}{" "}
                {t("showingentriestable.of")} {translatedRowCount}{" "}
                {t("showingentriestable.entries")}
              </div>
            )}
            <div>
              {/* <span>
Page{''}
<strong>
{pageIndex + 1} of {pageOptions.length}
</strong>{' '} 

</span>*/}
            </div>

          </div>
        }
        <div className="pagination">
          {!disbalePaginationFilter && (
            <div className="d-flex">
              <span className="pagination_gotopage">
                Go to page:
                <input
                  type="number"
                  min="1"
                  defaultValue={pageIndex + 1}
                  onChange={(e) => {
                    let pageNumber = Number(e.target.value);
                    if (pageNumber < 1 || isNaN(pageNumber)) {
                      pageNumber = 1; // Ensures minimum value of 1
                    }
                    gotoPage(pageNumber - 1);
                  }}
                  className="pagination_gotopage-input"
                />
              </span>
              <span>
                <select
                  className="pagination_select"
                  value={pageSize}
                  onChange={(e) => setPageSize(Number(e.target.value))}>
                  {[10, 50, 100, 500, 1000, 2000].map((pageSize) => (
                    <option key={pageSize} value={pageSize} style={{
                      background: theme === "light" ? "white" : "#252b48",
                      color: theme === "light" ? "#2b6591" : "#ffffff"
                    }}>
                      show {pageSize}
                    </option>
                  ))}
                </select>
              </span>
            </div>
          )}
          {!disbalePaginationFilter1 && (
            <>
              <button
                className="pagebtn mx-2"
                onClick={() => previousPage()}
                disabled={!canPreviousPage}>
                {"<"}
              </button>
              <button className="pagination_page">
                {translateNumber(pageIndex + 1)}{" "}
              </button>
              <button
                className="pagebtn"
                onClick={() => nextPage()}
                disabled={!canNextPage}>
                {">"}
              </button>{" "}
              <span className="right_pageno">
                {t("pagination.page_of", {
                  page: translateNumber(pageIndex + 1),
                  total: translateNumber(pageOptions.length),
                })}
              </span>
            </>
          )}
        </div>
      </div>
    </div>
  );
};

export default IncidentShowTableData;
